"use strict";
/**
 * This module is a collection of functions to deal with numbers,
 * such as formatting, displaying and parsing...
 * usage:
 * `import { functionName } from 'priority_utils/lib/number'`
 *
 *
 * @module number
 * @preferred
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValid = exports.strToFloat = exports.isNegative = exports.number = void 0;
/**
 * round10 returns the number rounded to 10
 * @param {number} value number
 *
 * @category Number
 */
function round10(value) {
    return Math.round(value / 10) * 10;
}
/**
 * number returns the number as string with ',' and fraction digits correctness
 * @param {number | string} value number
 * @param {number} minimumFractionDigits minimum fraction digits
 *
 * @category Number
 */
function number(value, minimumFractionDigits) {
    if (minimumFractionDigits === void 0) { minimumFractionDigits = 0; }
    if (value == null || value === '') {
        return value;
    }
    if (typeof value === 'number') {
        return value.toLocaleString('en', { minimumFractionDigits: minimumFractionDigits });
    }
    return Number(value.replace(/,/g, '')).toLocaleString('en', { minimumFractionDigits: minimumFractionDigits });
}
exports.number = number;
/**
 * isNegative returns true if number is negative
 * @param {string} value number
 *
 * @category Number
 */
function isNegative(value, thousandSign) {
    if (thousandSign === void 0) { thousandSign = ','; }
    if (!value) {
        return false;
    }
    var n = Number(value.split(thousandSign).join(''));
    return n < 0;
}
exports.isNegative = isNegative;
/**
 * strToFloat parses a string number to Float
 * @param {string} value string number
 *
 * @category Number
 */
function strToFloat(value, thousandSign) {
    if (thousandSign === void 0) { thousandSign = ','; }
    if (typeof value === 'string') {
        if (value.length > 0) {
            return parseFloat(value.split(thousandSign).join(''));
        }
        return 0;
    }
    return value;
}
exports.strToFloat = strToFloat;
/**
 * Return boolean if the number is valid
 * @param value string | number
 * @param decimal number numbers after '.'
 * @param maxLength number
 * @param positive boolean
 *
 * @category Number
 */
var isValid = function (value, decimal, maxLength, positive, thousandSign) {
    if (!value) {
        return true;
    }
    // make sure its a string
    var numberStr = value.toString();
    // remove thousandSign
    numberStr = numberStr.split(thousandSign || ',').join('');
    // if no decimal number
    if (decimal !== undefined && decimal === 0 && numberStr.includes('.')) {
        return false;
    }
    if (decimal > 0 && numberStr.split('.')[1] && numberStr.split('.')[1].length > decimal) {
        return false;
    }
    // include a char
    if (isNaN(numberStr) && numberStr !== '-') {
        return false;
    }
    // max length
    if (maxLength && numberStr.replace('.', '').length > maxLength) {
        return false;
    }
    // only positive number
    if (positive && numberStr.charAt(0) === '-') {
        return false;
    }
    // Do not allow spaces in numeric fields
    if (numberStr.includes(' ')) {
        return false;
    }
    return true;
};
exports.isValid = isValid;
